import { render, staticRenderFns } from "./cefloreco-footer.vue?vue&type=template&id=4ae86eea&scoped=true&"
import script from "./cefloreco-footer.vue?vue&type=script&lang=js&"
export * from "./cefloreco-footer.vue?vue&type=script&lang=js&"
import style0 from "./cefloreco-footer.vue?vue&type=style&index=0&id=4ae86eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae86eea",
  null
  
)

export default component.exports